import createIsPristine from './isPristine';


var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = createIsPristine(structure)(form, getFormState);
    return function (state) {
      return !isPristine(state);
    };
  };
};

export default createIsDirty;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/isDirty.js
// module id = 1782
// module chunks = 2